import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Col, Row } from 'react-bootstrap'
import { Card, Empty, Loading, Paragraph, TableV2 } from 'src/components'
import { toMoney } from 'src/utils/utilities'
import { selectReportSegmented } from 'src/selectors/report.selector'
import { showAlert } from 'src/actions/alert.actions'
import { handlerError, hasErrors } from 'src/selectors/error.selector'
import { actionTypes } from 'src/actions/report.actions'
import { actionTypes as dteAction } from 'src/actions/resolutions.actions'
import { loadingSelector } from 'src/selectors/loading.selector'

interface SegmentationReportContentProps {
  headers: ITableHeader[]
}

export const SegmentationReportContent = ({
  headers,
}: SegmentationReportContentProps) => {
  const dispatch = useDispatch()

  const loadingGetReport: boolean = useSelector(state =>
    loadingSelector([
      actionTypes.GET_SEGMENTATION_REPORT,
      actionTypes.GET_SEGMENTATION_REPORT_EXCEL,
    ])(state),
  )

  const hasErrorReport = useSelector(state =>
    hasErrors([
      actionTypes.GET_SEGMENTATION_REPORT,
      actionTypes.GET_SEGMENTATION_REPORT_EXCEL,
    ])(state),
  )

  const loadingDTE = useSelector(state => loadingSelector([dteAction.EXPORT_DTE])(state))
  const errorsDTE = useSelector(state => hasErrors([dteAction.EXPORT_DTE])(state))

  const report: ISegmentation[] = useSelector(selectReportSegmented)

  const downloading = loadingGetReport || loadingDTE

  const [flags, setFlags] = useState({ get: false, dte: false })

  useEffect(() => {
    if (loadingGetReport) setFlags({ ...flags, get: true })
    else if (flags.get) {
      setFlags({ ...flags, get: false })
      if (hasErrorReport) dispatch(showAlert(handlerError(hasErrorReport.message)))
    }
  }, [loadingGetReport])

  useEffect(() => {
    if (loadingDTE) setFlags({ ...flags, dte: true })
    else if (flags.dte) {
      setFlags({ ...flags, dte: false })
      if (errorsDTE) dispatch(showAlert(handlerError(errorsDTE.message)))
    }
  }, [loadingDTE])

  /** Recursive component that renders a Card if it is a segment or a TableV2 if it is data
   * @component
   * @param {ISegmentation[]} items List of data to render
   * @param {boolean} isSegment Indicates whether it is a segment or not
   * **/
  const renderContent = (items: ISegmentation[], isSegment: boolean) => {
    if (isSegment)
      return items.map(item => (
        <Col xl={12} key={item.id}>
          <Card
            title={item.name}
            white
            button={toMoney(item.total)}
            footer={toMoney(item.total)}>
            <Row>{renderContent(item.items, false)}</Row>
          </Card>
        </Col>
      ))
    else {
      const withSegment = items.some(i => i.segment)
      if (withSegment) return renderContent(items, true)
      else
        return (
          <Col xl={12}>
            <TableV2
              // @ts-ignore
              headers={headers || []}
              items={items}
              mobileAuto
            />
          </Col>
        )
    }
  }

  const isEmpty = !report || report.length === 0

  return downloading ? (
    <Loading show />
  ) : isEmpty ? (
    // @ts-ignore
    <Empty
      className={'self-center'}
      title={'No hay registros para mostrar'}
      hideButton
      subtitle={''}
      buttonTitle={'Verifica los filtros aplicados'}
      subtitleSecond={''}
    />
  ) : (
    <Row>
      <Col xl={12}>
        <div className={'space-between mb-3 px-3'}>
          <Paragraph bold size={'extraBig'}>
            TOTAL
          </Paragraph>
          <Paragraph bold size={'extraBig'}>
            {toMoney(report.reduce((total, i) => total + i.total, 0))}
          </Paragraph>
        </div>
      </Col>
      <Col xl={12}>
        <Row>{renderContent(report, true)}</Row>
      </Col>
    </Row>
  )
}
